@if (retrieving) {
  <spinner messageRelativePosition="bottom"> </spinner>
}

@if (!retrieving) {
  <table class="adminTable">
    <!--Table head-->
    <thead>
      <tr>
        <!-- Action Links Column -->
        @if (isSuperAdmin) {
          <th></th>
        }
        <th class="sortable-header" (click)="onSetSortClick('title')">
          Title
          @if (sort === 'title') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
        <th class="sortable-header" (click)="onSetSortClick('reservationId')">
          Reservation ID
          @if (sort === 'reservationId') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
        <th class="sortable-header" (click)="onSetSortClick('status')">
          Status
          @if (sort === 'status') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
        <th class="sortable-header" (click)="onSetSortClick('checkInCode')">
          Code In
          @if (sort === 'checkInCode') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
        <th class="sortable-header" (click)="onSetSortClick('checkOutCode')">
          Code Out
          @if (sort === 'checkOutCode') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
        <th class="sortable-header" (click)="onSetSortClick('emailAddress')">
          Name/Email/Phone
          @if (sort === 'emailAddress') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
        <!-- PK of CheckIn table -->
        <th class="sortable-header" (click)="onSetSortClick('checkInId')">
          CheckIn ID
          @if (sort === 'checkInId') {
            <span>
              @if (!sortDescending) {
                <i class="fa fa-sort-amount-asc" aria-hidden="true"></i>
              }
              @if (sortDescending) {
                <i class="fa fa-sort-amount-desc" aria-hidden="true"></i>
              }
            </span>
          }
        </th>
      </tr>
    </thead>
    <!--Table head-->
    <!--Table body-->
    @if (rows && !retrieving) {
      <tbody>
        @for (r of rows; track r) {
          <tr (click)="onSingleClick($event, r)" (dblclick)="onDoubleClick($event, r)">
            <!-- Action Links Column -->
            @if (isSuperAdmin) {
              <td></td>
            }
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.title }}
              </div>
            </td>
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.reservationId }} <link-to-booking-detail [bookingId]="r.bookingId"></link-to-booking-detail>
                <link-to-new-admin-listing [listingId]="r.listingId"></link-to-new-admin-listing>
              </div>
            </td>
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.status }}
              </div>
            </td>
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.checkInCode }}
                @if (isSuperAdmin && r && r.checkInCode) {
                  <div
                    (click)="onManualCheckIn(r)"
                    [ngClass]="{ link: !r.submitting, 'link-disabled': r.submitting }"
                    >
                    Manual Check In
                  </div>
                }
              </div>
            </td>
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.checkOutCode }}
                @if (isSuperAdmin && r && r.checkOutCode) {
                  <div
                    (click)="onManualCheckOut(r)"
                    [ngClass]="{ link: !r.submitting, 'link-disabled': r.submitting }"
                    >
                    Manual Check Out
                  </div>
                }
              </div>
            </td>
            <td>
              <div class="email-cell" (click)="onSingleClick(r)">
                @if (r.fullName) {
                  <div>
                    {{ r.fullName }}
                  </div>
                }
                @if (r.mobilePhone) {
                  <div>
                    {{ r.mobilePhone }}
                  </div>
                }
                <div>
                  @if (r.emailAddress) {
                    <span>{{ r.emailAddress }} </span>
                  }
                  <link-to-user-account-detail [openInNewTab]="true" [userAccountId]="r.userAccountId"></link-to-user-account-detail>
                </div>
              </div>
            </td>
            <td>
              <div (click)="onSingleClick(r)">
                {{ r.checkInId }}
              </div>
            </td>
          </tr>
        }
      </tbody>
    }
    <!--Table body-->
  </table>
}
